export const OutputDocumentTemplateType = {
	load_doc_template: 1,
	unload_doc_template: 2,
};

export const InvoiceDocumentTemplateType = {
	invoice_template: 3,
};

export const PalletBoxDocumentTemplateType = {
	pallet_label_template: 4,
	box_label_template: 5,
};
export const InternalPalletLabelDocumentTemplateType = {
	internal_pallet_label_template: 8,
};

export const PrintPalletsDocumentTemplateType = {
	picking_list_template: 6,
	intake_list_template: 7,
};

export const CustomerDocumentTemplateType = {
	...OutputDocumentTemplateType,
	...PalletBoxDocumentTemplateType,
};

export const DefaultDocumentTemplateType = {
	...OutputDocumentTemplateType,
	...InvoiceDocumentTemplateType,
	...PrintPalletsDocumentTemplateType,
	...PalletBoxDocumentTemplateType,
	...InternalPalletLabelDocumentTemplateType,
};

export const LabelDocumentTemplateTypes = [
	...Object.values(PalletBoxDocumentTemplateType),
	...Object.values(InternalPalletLabelDocumentTemplateType),
];

export const DefaultDocumentTemplateWithExcludeCustomFields = {
	...InvoiceDocumentTemplateType,
	...PalletBoxDocumentTemplateType,
};
